import React, { useEffect, useState } from "react";
import Layout from "../../components/shared/Layout/Layout";
import momemt from "moment";
import API from "../../services/API";

const Hospitals = () => {
  const [data, setData] = useState([]);
  //find the Hospital records
  const getHospital = async () => {
    try {
      const { data } = await API.get("/inventory/get-hospital");
      if (data?.success) {
        setData(data?.hospital);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getHospital();
  }, []);

  return (
    <Layout>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">EmailID</th>
            <th scope="col">Phone</th>
            <th scope="col">Address</th>
            <th scope="col">Date</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((record) => (
            <tr key={record._id}>
              <td>{record.hospitalName}</td>
              <td>{record.email}</td>
              <td>{record.phone}</td>
              <td>{record.address}</td>

              <td>{momemt(record.createdAt).format("DD/MM/YYYY hh:mm A")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Layout>
  );
};

export default Hospitals;
